import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29 6H8V2.93a1 1 0 00-2 0V6H2.89a1 1 0 000 2H6v21.06A1 1 0 007 30a1 1 0 001-.93V8h4v2h2V8h10v2h2V8h3a1 1 0 000-2z"/><rect x="10" y="10" width="18" height="13" rx="2"/>';
export var YardSignSVG = function YardSignSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
YardSignSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(YardSignSVG);